import { useEffect, useState } from "react";

// Ekran genişliği sorgusu (matchMedia) — mobil/masaüstü için farklı bileşen ağacı kurmak amacıyla
export function useMediaQuery(query) {
  const get = () => typeof window !== "undefined" && window.matchMedia(query).matches;
  const [match, setMatch] = useState(get);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const h = (e) => setMatch(e.matches);
    setMatch(mq.matches);
    mq.addEventListener("change", h);
    return () => mq.removeEventListener("change", h);
  }, [query]);
  return match;
}

export const useIsDesktop = () => useMediaQuery("(min-width: 1024px)");
